import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {Connection, Shape} from 'diagram-js/lib/model';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {startGatewayToScriptTaskConn, startGatewayToUserTaskConn} from '@ispm/shared/bpmn-io/sub-process-consts';
import {scriptTaskType, userTaskType} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';

export class NodeResetChildrenDataHandler implements CommandHandler {

  constructor(private modeling, private pathwaysModeling: PathwaysModeling, private bpmnExtensionHelper: BpmnExtensionHelper,private elementRegistry) {
  }

  postExecute(context): any {
    const element = context.element;
    const childrenData = context.childrenData;
    this.clearSubProcessChildrenData(element);
    const nodeDetails = ModelingUtil.getNodeDetails(element);
    delete nodeDetails.questions;
    this.bpmnExtensionHelper.replaceExtension(element, nodeDetails);
    this.pathwaysModeling.calculateChildsData(element, childrenData);
  }

  private clearSubProcessChildrenData(sourceElement: Shape) {
    const scriptTask: Shape = ModelingUtil.getScriptAndUserTask(sourceElement, scriptTaskType,this.elementRegistry);
    const userTask: Shape = ModelingUtil.getScriptAndUserTask(sourceElement, userTaskType,this.elementRegistry);
    if (scriptTask && userTask) {
      const scriptConnectionID = `${scriptTask.id}_${startGatewayToScriptTaskConn}`;
      const userConnectionID = `${userTask.id}_${startGatewayToUserTaskConn}`;
      this.modeling.updateProperties(scriptTask, {script: ''});

      const startGatewayToScriptTaskConnection: Connection = ModelingUtil.getChildConnectionById(sourceElement, scriptConnectionID,this.elementRegistry);
      this.pathwaysModeling.clearConnectionConditionExpression(startGatewayToScriptTaskConnection);

      const startGatewayToUserTaskConnection: Connection = ModelingUtil.getChildConnectionById(sourceElement, userConnectionID,this.elementRegistry);
      this.pathwaysModeling.clearConnectionConditionExpression(startGatewayToUserTaskConnection);
    } else {
      console.warn("[NodeResetChildrenDataHandler] scriptTask && userTask not found for element id " + sourceElement.id);
    }
  }
}
